/**
 * projects.js — Central data source for all portfolio projects.
 * To add a new project: simply append an object to this array.
 * No core logic needs to be changed.
 *
 * Fields:
 *   id        — unique slug used in URL routing
 *   image     — path to thumbnail (place images in /public/images/)
 *   liveUrl   — optional: URL to deployed demo
 *   githubUrl — optional: URL to GitHub repo
 *   en        — English content { title, shortDesc, fullDesc }
 *   fr        — French content  { title, shortDesc, fullDesc }
 */

const projects = [
  {
    id: "boubaker-net",
    publishDate: "2025-02-05T01:00:00",
    image: "/portfolio/boubaker.png",
    liveUrl: "https://boubaker.net",
    githubUrl: "",
    en: {
      title: "Boubaker.net",
      shortDesc: "Personal website and biography created with Symfony.",
      fullDesc:
        "This website is used as a portfolio, blog, biography and organisation and communication tool for the musician Heddy BOUBAKER (who is also my father). It was created using the Symfony php framework to allow him to dynamically manage the content of the website.",
    },
    fr: {
      title: "Boubaker.net",
      shortDesc: "Un site perso / biographie crée avec symfony.",
      fullDesc:
        "Ce site sert de portfolio, blog, biographie et outil d'organisation et de communication pour le musicien Heddy BOUBAKER (qui est accessoirement aussi mon père). Il a été fait avec le framework php Symfony afin de lui permettre d'éditer le contenu de façon dynamique.",
    },
  },
  {
    id: "morpion",
    publishDate: "2024-01-03T01:00:00",
    image: "/portfolio/morpion.png",
    liveUrl: "https://tommy-bou.github.io/Tic-Tac-Toe/",
    githubUrl: "https://github.com/Tommy-BOU/Tic-Tac-Toe",
    en: {
      title: "Tic Tac Toe",
      shortDesc:
        "A simple Tic Tac Toe game built with HTML, CSS, and JavaScript.",
      fullDesc:
        "This is a classic Tic Tac Toe game implemented with HTML, CSS, and JavaScript. It allows two players to compete against each other.",
    },
    fr: {
      title: "Morpion",
      shortDesc:
        "Un simple jeu de morpion construit avec HTML, CSS et JavaScript.",
      fullDesc:
        "Il s'agit d'un jeu de morpion classique implémenté avec HTML, CSS et JavaScript. Il permet à deux joueurs de s'affronter.",
    },
  },
  {
    id: "georgia-restaurant",
    publishDate: "2023-12-06T01:00:00",
    image: "/portfolio/georgia-restaurant.png",
    liveUrl: "https://tommy-bou.github.io/Template-4/",
    githubUrl: "https://github.com/Tommy-BOU/Template-4",
    en: {
      title: "Georgia restaurant",
      shortDesc: "A static web page created with SASS.",
      fullDesc:
        "For this project, I had to create a static web page using the presentation language SASS.",
    },
    fr: {
      title: "Georgia restaurant",
      shortDesc: "Une page web statique crée avec SASS.",
      fullDesc:
        "Pour ce projet, j'ai reçu la tâche de crée une page web statique en utilisant le langage de présentation SASS.",
    },
  },
  {
    id: "eventgrids",
    publishDate: "2023-12-07T01:00:00",
    image: "/portfolio/euro-conf-img.png",
    liveUrl: "https://tommy-bou.github.io/Template-5/index.html",
    githubUrl: "https://github.com/Tommy-BOU/Template-5",
    en: {
      title: "EventGrids",
      shortDesc: "A complete static website created with SASS and Bootstrap.",
      fullDesc:
        "For this group project with 4 members, we had to create a static web page using the languages HTML, CSS, SASS, and Bootstrap.",
    },
    fr: {
      title: "EventGrids",
      shortDesc: "Un site web statique complet crée avec SASS et Bootstrap.",
      fullDesc:
        "Pour ce projet de groupe à 4, nous avions pour tâche de réalisé un site web statique en utilisant les langages HTML, CSS, SASS, et Bootstrap.",
    },
  },
  {
    id: "webwares",
    publishDate: "2024-01-04T01:00:00",
    image: "/portfolio/webwares.png",
    liveUrl: "https://tommy-bou.github.io/Projet-WebWares/",
    githubUrl: "https://github.com/Tommy-BOU/Projet-WebWares",
    en: {
      title: "WebWares",
      shortDesc: "A static web page created with SASS.",
      fullDesc:
        "For this group project, we were 4 people who had to create an e-shop website for a furniture wholesaler using the Vue.js framework. This site contain a functional register and login system, as well as a product list, a shopping cart, an order system and an admin backoffice to allow the admins to administrate the website. All of it use the local storage as database.",
    },
    fr: {
      title: "WebWares",
      shortDesc: "Une page web statique crée avec SASS.",
      fullDesc:
        "Pour ce projet de groupe à 4, nous avons dû crée un site d'e-commerce pour un grossiste d'ameublement en utilisant le framework VueJS. Ce site contient un système fonctionnel d'inscription, de connexion, de liste de produits, d'un panier, d'un système de commande ainsi que d'un panel admin permettant aux administrateurs de gérer l'ensemble. Le tout utilisant le local storage comme base de données.",
    },
  },
];

export default projects;
